import type { Routes } from '@angular/router';
import { authGuard } from '@/routes/guards/auth.guard';
import { guestGuard } from '@/routes/guards/guest.guard';
import { permissionGuard } from '@/routes/guards/permission.guard';
import { APP_PATHS } from '@/routes/app.paths';

export const AUTH_ROUTES: Routes = [
  {
    path: APP_PATHS.activity,
    loadChildren: () => import('@/routes/activity.routes').then((m) => m.ACTIVITY_ROUTES),
  },
  {
    path: APP_PATHS.opportunity,
    loadChildren: () => import('@/routes/opportunity.routes').then((m) => m.OPPORTUNITIES_ROUTES),
  },
  {
    path: APP_PATHS.archive,
    loadChildren: () => import('@/routes/archive.routes').then((m) => m.ARCHIVES_ROUTES),
  },
  {
    path: APP_PATHS.users,
    loadChildren: () => import('@/routes/users.routes').then((m) => m.USERS_ROUTES),
  },
  {
    path: APP_PATHS.roles,
    loadChildren: () => import('@/routes/roles.routes').then((m) => m.ROLES_ROUTES),
  },
];

export const routes: Routes = [
  { path: '', redirectTo: APP_PATHS.activity, pathMatch: 'full' },
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [permissionGuard],
    children: AUTH_ROUTES,
  },
  {
    path: APP_PATHS.login,
    canActivate: [guestGuard],
    loadComponent: () => import('@/features/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: APP_PATHS.samlCallback,
    canActivate: [guestGuard],
    loadComponent: () =>
      import('@/features/saml-callback/saml-callback.component').then((m) => m.SamlCallbackComponent),
  },
  {
    path: APP_PATHS.forgotPassword,
    canActivate: [guestGuard],
    loadComponent: () =>
      import('@/features/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@/features/forgot-password/request-code/request-code.component').then((m) => m.RequestCodeComponent),
      },
      {
        path: APP_PATHS.forgotPasswordReset,
        loadComponent: () =>
          import('@/features/forgot-password/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordComponent,
          ),
      },
    ],
  },
  { path: '**', redirectTo: APP_PATHS.activity },
];
